(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["chance-demo"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('store-chance-demo')) {
    customElements.define('store-chance-demo', class extends HTMLElement {
      connectedCallback() {
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.initializeDemo(), { once: true });
        } else {
          this.initializeDemo();
        }
      }
      initializeDemo() {
        if (this.initialized || !this.isConnected) return;
        const create = this.querySelector('[data-chance-demo-create]');
        const reset = this.querySelector('[data-chance-demo-reset]');
        const receipt = this.querySelector('[data-chance-demo-receipt]');
        const heading = this.querySelector('[data-chance-demo-heading]');
        if (!create || !reset || !receipt || !heading) return;
        this.initialized = true;
        create.hidden = false;
        create.addEventListener('click', () => {
          create.hidden = true;
          receipt.hidden = false;
          heading.focus();
        });
        reset.addEventListener('click', () => {
          receipt.hidden = true;
          create.hidden = false;
          create.focus();
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["store-pass-check"] && !Shopify.designMode) return;
  try {
    (() => {
  "use strict";
  if (window.location.protocol !== "https:") return;
  const source = document.currentScript?.src;
  let load = null;
  function initialize(root) {
    const passMode = root.dataset.storeVerificationMode === "pass";
    if (root.dataset.storeInlineEnabled !== "true" || !/^[a-z0-9][a-z0-9-]*\.myshopify\.com$/.test(root.dataset.shop || "") || root.dataset.shop === "storeshq.myshopify.com" || (passMode ? root.dataset.shop !== "xbter1-jy.myshopify.com" : !root.dataset.gateConfiguration) || root.dataset.storeGateReady === "true") return;
    const action = root.querySelector("[data-store-gate-action]");
    const status = root.querySelector("[data-store-gate-status]");
    if (!action || !status) return;
    root.dataset.storeGateReady = "true";
    root.dataset.storeInlineBoot = "pending";
    if (!passMode && root.dataset.disableNativePurchase === "true") document.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
      if (!root.contains(form)) { form.setAttribute("data-store-gate-native-purchase", "hidden"); form.setAttribute("aria-hidden", "true"); }
    });
    const label = (key) => root.querySelector(`[data-store-inline-copy="${key}"]`)?.textContent || "Please reload and try again.";
    async function start(event) {
      if (!root.dataset.storeInlineBoot) { action.removeEventListener("click", start, true); return; }
      event.stopImmediatePropagation();
      if (action.disabled) return;
      action.disabled = true; status.textContent = label("checking");
      try {
        if (!passMode && !source) throw new Error("Runtime unavailable");
        if (!load) load = new Promise((resolve, reject) => {
          const script = document.createElement("script");
          let settled = false;
          const finish = (failed) => {
            if (settled) return;
            settled = true;
            clearTimeout(timeout);
            script.onload = null;
            script.onerror = null;
            if (failed) { script.remove(); load = null; reject(new Error("Runtime unavailable")); }
            else resolve();
          };
          const timeout = setTimeout(() => finish(true), 20000);
          script.src = passMode ? "https://gate.sto.re/store-gate-pass-inline-v1.js" : new URL("store-gate-inline.js", source).href;
          script.onload = () => finish(false);
          script.onerror = () => finish(true);
          document.head.append(script);
        });
        await load;
        if (root.dataset.storeInlineBoot) throw new Error("Runtime unavailable");
        action.removeEventListener("click", start, true);
        action.click();
      } catch { action.disabled = false; status.textContent = label("failed"); }
    }
    action.addEventListener("click", start, true);
  }
  const all = () => document.querySelectorAll('[data-store-gate-root][data-store-verification-mode="pass"]').forEach(initialize);
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", all, { once: true }); else all();
  document.addEventListener("shopify:section:load", all);
})();
  } catch(e) { console.error(e); }
})();

})();
